import {environment} from '../environment'
import axios from 'axios';
import { useBasicAuth } from '../../shared/components/auth/withBasicAuth';

const urlAPI = environment.getApi('usoSustentavelShapeFile');

export const check = () => useBasicAuth.checkToken();

export const findGeologiaShapeUsoSustentavelFileById = (id) => 
  axios.get(urlAPI + "/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllGeologiaShapeUsoSustentavelFile = () => 
  axios.get(urlAPI + "/findAll", environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllGeologiaShapeUsoSustentavelFileByDeleted = (value) => 
  axios.get(urlAPI + "/deleted/" + value , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const updateGeologiaShapeUsoSustentavelFile = (fileRequest) => 
  axios.post(urlAPI + "/updateGeologiaShapeFileUsoSustentavel" , JSON.stringify(fileRequest), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
  

export const deleteGeologiaShapeUsoSustentavelFile = (id) => 
  axios.delete(urlAPI + "/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });